import { render, staticRenderFns } from "./ProfessionalInfoAHPEdit.vue?vue&type=template&id=fd2b90fc"
import script from "./ProfessionalInfoAHPEdit.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoAHPEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports